import React from 'react';
import { usePage } from '@kizi/comparator-core';
import { Div, P } from '@kizi/core-components';

export const CustomerBenefit = () => {
  const { state } = usePage();
  return state?.benefitInfo ? (
    <Div variant="customerBenefit">
      {(state.benefitInfo as string[]).map((item, index) => (
        <P variant="footnoteAdditionalInfo" key={index}>
          {item}
        </P>
      ))}
    </Div>
  ) : null;
};
